import React, { Component } from 'react';
import _ from 'lodash';
import firebase from '../helper/firebase';

// import { Link } from 'react-router-dom';

import Snack from '../components/Snack';
import ApplicantCardHeader from '../components/ApplicantCardHeader';
import SkeletonCard from '../components/SkeletonCard';

import Fade from 'material-ui/transitions/Fade';

import { ReactGoogleAnalytics } from '../helper/functions';

import {
	Button,
	Card,
	CardActions,
	CardContent,
	Divider,
	LinearProgress,
	TextField,
	Typography
} from 'material-ui';

// import CheckIcon from 'material-ui-icons/Check';

const style = {
	jobActions: {
		marginBotton: '5px'
	},
	cvName: {
		backgroundColor: '#eeeeee',
		padding: '0 21px',
		color: 'rgba(135,135,135,1)',
		borderRadius: '3px',
		height: '41px',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		marginLeft: '4px'
	},
	cvError: {
		color: 'red'
	}
};

export default class ApplyCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			applicationLoading: true,
			linkedIn: '',
			email: '',
			displayName: '',
			snackStatus: false,
			snackMessage: '',
			uploadProgress: 0
		};
	}

	componentDidMount() {
		this.getInfo();
		this.setState({
			uid: this.props.user.uid,
			user: this.props.user,
			email: this.props.user.email,
			displayName: this.props.user.displayName,
			job: this.props.job,
			applicationLoading: true
		});
	}

	getInfo = () => {
		const ref = firebase.database().ref();
		const uid = this.props.user.uid;
		const jid = this.props.job.jid;
		ref
			.child(`applications/${jid}/${uid}`)
			.once('value')
			.then(applicationSnap => {
				if (!!applicationSnap.val() && !!applicationSnap.val().cv) {
					this.setState({
						application: applicationSnap.val(),
						applicationLoading: false,
						cvFilename: applicationSnap.val().cv.filename,
						linkedIn: applicationSnap.val().linkedIn
					});
				} else {
					this.setState({
						application: {},
						applicationLoading: false,
						linkedIn: ''
					});
				}
			})
			.catch(applicationError => {
				this.setState({
					snackStatus: true,
					snackMessage: `Error. Please check the link.`
				});
			});
	};

	renderApplication = () => {
		if (_.isEmpty(this.props.job) || this.props.job.status !== 'published')
			return;
		let html = [];
		let card = (
			<Fade in={true} key="ApplicationForm">
				<Card className="card">
					{!!this.props.user && (
						<ApplicantCardHeader applicant={this.props.user} />
					)}
					<Divider light />
					<CardContent>
						<TextField
							error={this.state.nameError}
							required
							fullWidth
							id="name"
							label="Full Name"
							value={this.state.displayName}
							onChange={event =>
								this.setState({
									displayName: event.target.value,
									nameError: false,
									linkedInError: false,
									emailError: false,
									cvError: false
								})
							}
							margin="normal"
						/>
						{!this.state.loggedIn && (
							<TextField
								error={this.state.emailError}
								required
								fullWidth
								id="email"
								label="Email Address"
								value={this.state.email}
								onChange={event =>
									this.setState({
										email: event.target.value,
										nameError: false,
										linkedInError: false,
										emailError: false,
										cvError: false
									})
								}
								margin="normal"
							/>
						)}
						<TextField
							error={this.state.linkedInError}
							helperText="E.g.: https://www.linkedin.com/in/jhughes"
							fullWidth
							id="linkedIn"
							label="LinkedIn Profile URL"
							value={this.state.linkedIn}
							onChange={event =>
								this.setState({
									linkedIn: event.target.value,
									nameError: false,
									linkedInError: false,
									emailError: false,
									cvError: false
								})
							}
							margin="normal"
						/>
					</CardContent>
					<CardActions className="cardActions">
						<input
							onChange={this.handleCvSelect}
							accept="application/msword, text/plain, application/pdf"
							style={{ display: 'none' }}
							id="file"
							multiple
							type="file"
						/>
						<label style={{ margin: 0 }} htmlFor="file">
							<Button className="cardActionsBtn" raised component="span">
								Upload
							</Button>
						</label>
						<Typography style={this.state.cvError ? style.cvError : null}>
							{' '}
							*{' '}
						</Typography>
						{this.state.cvFilename && (
							<Button
								disabled={true}
								style={style.cvName}
								align="left"
								color="inherit"
								type="body2"
							>
								Filename: {this.state.cvFilename}
							</Button>
						)}
					</CardActions>
					<LinearProgress
						style={
							this.state.applying ||
							(this.state.uploadProgress > 0 && this.state.uploadProgress < 100)
								? { opacity: 1 }
								: { opacity: 0 }
						}
						color="accent"
						mode="determinate"
						value={this.state.uploadProgress}
					/>
					<CardActions className="cardActions" style={style.jobActions}>
						<Button
							className="cardActionsBtn"
							disabled={this.state.applying}
							onClick={!this.state.applying ? this.validate : null}
							raised={!this.state.applying}
							color={'primary'}
						>
							{this.state.applying
								? 'Applying'
								: (this.state.applied && !this.state.cvFile) ||
								  (!_.isEmpty(this.state.application) && !this.state.cvFile)
									? 'Applied'
									: 'Apply'}
						</Button>
					</CardActions>
				</Card>
			</Fade>
		);
		html.push(card);
		return html;
	};

	handleCvSelect = e => {
		let file = e.target.files[0];
		// if (file.type.match('image')) {
		let reader = new FileReader(file);
		reader.onloadend = () => {
			this.setState({
				cvFile: file,
				cvFilename: file.name,
				cvFileUrl: reader.result,
				nameError: false,
				linkedInError: false,
				emailError: false,
				cvError: false
			});
		};
		if (file !== undefined) {
			reader.readAsDataURL(file);
		}
		// file!==undefined?reader.readAsDataURL(file):null
		// };
	};

	validate = () => {
		this.setState({ applying: true });
		if (this.state.displayName.length < 1) {
			this.setState({ nameError: true, applying: false });
			return;
		}
		if (this.state.email.length < 1) {
			this.setState({ emailError: true, applying: false });
			return;
		}
		if (!this.state.cvFilename || this.state.cvFilename.length < 1) {
			this.setState({ cvError: true, applying: false });
			return;
		}
		if (
			!this.state.cvFile ||
			!(
				this.state.cvFile.type === 'application/msword' ||
				this.state.cvFile.type === 'text/plain' ||
				this.state.cvFile.type === 'application/pdf'
			)
		) {
			this.setState({ cvError: true, applying: false });
			return;
		}
		this.state.application && !this.state.cvFile
			? this.apply(this.state.application.cv)
			: this.uploadCv();
	};

	uploadCv = () => {
		const { job, oid } = this.props;
		const { uid } = this.props.user;
		let { cvFile } = this.state;
		let self = this;
		let meta = {
			customMetadata: {
				name: cvFile.name,
				uid: uid,
				oid: oid,
				jid: job.jid
			}
		};
		let storageRef = firebase.storage().ref(`applications/${job.jid}/${uid}`);
		let task = storageRef.put(cvFile, meta);
		task.on(
			'state_changed',
			snapshot => {
				self.setState({
					uploadProgress: snapshot.bytesTransferred / snapshot.totalBytes * 95
				});
			},
			err => {
				console.log(`There was an error.`);
				console.log(err);
				self.setState({
					applying: false,
					applied: false,
					uploadProgress: 0,
					snackStatus: true,
					snackMessage: `Upload Error: ${err.code}. Please try again.`
				});
			},
			() => {
				let cvObject = {};
				storageRef
					.getMetadata()
					.then(metadata => {
						cvObject.filename = metadata.customMetadata.name;
						cvObject.bucket = metadata.bucket;
						cvObject.contentType = metadata.contentType;
						cvObject.fullPath = metadata.fullPath;
						cvObject.name = metadata.name;
						cvObject.size = metadata.size;
						cvObject.timeCreated = metadata.timeCreated;
						cvObject.updated = metadata.updated;
						cvObject.downloadURLs = metadata.downloadURLs;
						self.setState(
							{
								cvObject
							},
							this.apply(cvObject)
						);
					})
					.catch(uploadError => {
						this.setState({
							applying: false,
							applied: false,
							uploadProgress: 0,
							snackStatus: true,
							snackMessage: `Upload Error: ${
								uploadError.code
							}. Please try again.`
						});
					});
			}
		);
	};

	apply = cvObject => {
		let promises = [];
		const ref = firebase.database().ref();
		const { user, oid, job } = this.props;
		const applicationKey = user.uid
			? user.uid
			: ref.child(`applications`).push().key;
		const timestamp = Date.now();
		const applicationsObj = {
			cv: cvObject,
			oid: oid,
			jid: job.jid,
			uid: user.uid ? user.uid : null,
			email: this.state.email,
			displayName: this.state.displayName,
			linkedIn: this.state.linkedIn,
			photoURL: user.photoURL ? user.photoURL : null,
			timestamp: timestamp
		};
		const applicationsPromise = ref
			.child(`applications/${job.jid}/${applicationKey}`)
			.update(applicationsObj);
		promises.push(applicationsPromise);
		const myApplicationObj = {
			oid: oid,
			jid: job.jid,
			timestamp: timestamp
		};
		const myApplicationPromise = ref
			.child(`myApplications/${user.uid}/${job.jid}`)
			.update(myApplicationObj);
		promises.push(myApplicationPromise);
		Promise.all(promises)
			.then(() => {
				ReactGoogleAnalytics('Jobs', 'Apply', job.jid, null, null);
				ReactGoogleAnalytics('Offers', 'Apply', oid, null, null);
				this.setState({
					applying: false,
					applied: true,
					cvFile: null,
					uploadProgress: 100,
					snackStatus: true,
					snackMessage: 'Application Submitted.'
				});
			})
			.catch(err => {
				this.setState({
					applying: false,
					applied: false,
					uploadProgress: 0,
					snackStatus: true,
					snackMessage: 'Error. Application Not Saved. Please try again.'
				});
			});
	};

	closeSnack = () => this.setState({ snackStatus: false, snackMessage: '' });

	render() {
		console.log(this.state);
		return (
			<React.Fragment>
				{!!this.state.applicationLoading && (
					<SkeletonCard header={true} content={true} actions={true} />
				)}

				{!this.state.applicationLoading && this.renderApplication()}

				<Snack
					snackStatus={this.state.snackStatus}
					snackMessage={this.state.snackMessage}
					closeSnack={() => {
						this.closeSnack();
					}}
				/>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/ApplyCard.js